<template>
  <div id="wrap-marquee-container" v-if="dataList.length > 0">
    <div class="marquee-container">
      <div class="marquee-box" @mouseover="mouseover" @mouseout="mouseout">
        <div class="wrap-content">
          <transition name="fade">
            <span
              @click="openMarquee()"
              class="content cursorPointer"
              :key="counter"
            >
              {{ dataList[counter].subject }}
              <i
                v-if="dataList[counter].contentType === 'url'"
                class="el-icon-copy-document new-window"
              />
            </span>
          </transition>
        </div>

        <i
          class="el-icon-caret-top"
          style="top: -2px"
          :class="dataList.length < 2 ? 'btn-disabled' : 'cursorPointer'"
          @click="marqueeSwitch('prev')"
        />
        <i
          class="el-icon-caret-bottom"
          style="top: 13px"
          :class="dataList.length < 2 ? 'btn-disabled' : 'cursorPointer'"
          @click="marqueeSwitch('next')"
        />

        <el-tooltip content="公告中心" placement="bottom" effect="light">
          <i
            class="el-icon-chat-line-square marquee-center-icon cursorPointer"
            @click="marqueeCenter()"
          />
        </el-tooltip>
      </div>
    </div>

    <!-- 公告内容弹框 -->
    <el-dialog
      id="marquee-html-content"
      v-if="marqueeObj"
      top="5vh"
      center
      :title="marqueeObj.subject"
      :visible="dialogVisible"
      @close="
        marqueeObj = null;
        dialogVisible = false;
      "
    >
      <div class="marquee-content" v-html="marqueeObj.content" />
    </el-dialog>
    <!-- End 公告内容弹框 -->

    <!-- 公告中心弹框 -->
    <el-dialog
      top="1vh"
      width="550px"
      center
      title="公告中心"
      :visible="marqueeCenterVisible"
      @close="marqueeCenterVisible = false"
    >
      <ul v-for="item in dataList" :key="item.id">
        <li class="cursorPointer" @click="openMarquee(item)">
          <el-link class="center-subject" type="primary">
            {{ item.subject }}

            <i
              v-if="item.contentType === 'url'"
              class="el-icon-copy-document"
            />
          </el-link>
        </li>
      </ul>
    </el-dialog>
    <!-- End 公告中心弹框 -->
  </div>
</template>

<script>
import { listMarqueeBulletins } from "@/api/bulletin";

export default {
  data() {
    return {
      counter: 0, // 当前轮拨公告 index
      timer: null, // 计时器
      timing: 4000, // ms
      marqueeObj: null, // 公告内容 obj
      dialogVisible: false, // 公告内容弹框
      marqueeCenterVisible: false, // 公告中心弹框
      mediaDomain: null,
      dataList: [], // 公告列表
    };
  },
  mounted() {
    this.getMarqueeList();
  },
  beforeDestroy() {
    this.mouseover();
  },
  methods: {
    // 公告中心
    marqueeCenter() {
      this.marqueeCenterVisible = true;
    },
    // 切换上、下则
    marqueeSwitch(switchTo) {
      if (this.dataList.length > 1) {
        this.counter =
          switchTo === "prev"
            ? this.counter > 0
              ? this.counter - 1
              : this.dataList.length - 1
            : this.counter === this.dataList.length - 1
            ? 0
            : this.counter + 1;
      }
    },
    // 开启公告内容
    openMarquee(item) {
      this.marqueeObj = item || this.dataList[this.counter];
      // 如果是 url 则另开窗口
      if (this.marqueeObj.contentType === "url") {
        window.open(this.marqueeObj.content);
        return;
      }
      // 将文件路径还原至相对路径
      this.marqueeObj.content = this.marqueeObj.content.replaceAll(
        'src="/',
        `src="${this.mediaDomain}/file/`
      );
      this.dialogVisible = true;
    },
    // 跑马灯计时机
    timerStart() {
      this.timer = setInterval(() => {
        this.counter =
          this.counter === this.dataList.length - 1 ? 0 : this.counter + 1;
      }, this.timing);
    },
    mouseover() {
      clearInterval(this.timer);
      this.timer = null;
    },
    mouseout() {
      this.timerStart();
    },
    // 取得公告列表
    getMarqueeList() {
      listMarqueeBulletins().then((res) => {
        this.dataList = res.data.list;
        this.mediaDomain = res.data.mediaDomain;
        this.timerStart();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
#wrap-marquee-container {
  /deep/ {
    #marquee-html-content {
      width: 98%;
      margin: 0 auto;
      .el-dialog {
        width: 90%;
      }
      .el-dialog__body {
        padding: 20px;
      }
      .el-dialog__headerbtn {
        top: 5px;
        right: 7px;
        font-size: 30px;
        .el-dialog__close {
          color: #000;
        }
      }
      .el-dialog__header {
        padding: 10px 50px;
      }
    }
  }
  .center-subject {
    font-size: 15px;
  }
  .marquee-container {
    width: 250px;
    position: absolute;
    right: 190px;
    top: 9px;
    animation: shake 1.2s forwards;
    z-index: 1000;
    .marquee-center-icon {
      position: absolute;
      right: -55px;
      top: 3px;
      color: #666;
      font-size: 22px;
    }
    .marquee-icon {
      cursor: pointer;
      position: absolute;
      left: -23px;
      top: 8px;
    }
    .marquee-box {
      position: relative;
      .new-window {
        position: absolute;
        right: 11px;
        top: 7px;
        color: #999;
      }
      .btn-disabled {
        cursor: default;
        opacity: 0.2;
      }
      .el-icon-caret-top,
      .el-icon-caret-bottom {
        color: #ccc;
        position: absolute;
        right: -25px;
        transition: all 0.5s ease-in-out;
        &:hover {
          color: #333;
        }
      }
      .wrap-content {
        width: 100%;
        background-color: #fbfbfb;
        border-radius: 30px;
        height: 28px;
      }
      .content {
        padding: 7px 18px 7px 12px;
        font-weight: 600;
        font-size: 13px;
        color: #666;
        width: 100%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        position: absolute;
      }
    }
  }
  .fade-enter-active,
  .fade-leave-active {
    transition: all 0.6s linear;
  }
  .fade-enter {
    transform: translateY(15px);
    opacity: 0;
  }
  .fade-leave-to {
    opacity: 0;
  }
  @keyframes shake {
    0% {
      transform: translate(0, -8px);
    }
    20% {
      transform: translate(0, 4px);
    }
    30% {
      transform: translate(0, -5px);
    }
    40% {
      transform: translate(0, 2px);
    }
    50% {
      transform: translate(0, -1px);
    }
    100% {
      transform: translate(0, 1px);
    }
  }
}

@media screen and (max-width: 1000px) {
  #wrap-marquee-container {
    display: none;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/layout/components/Marquee.vue